var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-container"},_vm._l((_vm.detailComponentList),function(item,index){return _c(item.component,_vm._b({key:index,ref:`component_${item.type}_${index}`,refInFor:true,tag:"component",staticClass:"body-content",attrs:{"is-edit-mode":false}},'component',item.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }